export default "/icon-nav-news.svg";